
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/types/loan";
import { PersonalBasicInfoFieldsHe } from "./PersonalBasicInfoFieldsHe";
import { HebrewTermsCheckbox } from "./HebrewTermsCheckbox";

interface HebrewPersonalInfoSectionProps {
  form: UseFormReturn<FormValues>;
  setTermsOpen: (value: boolean) => void;
  setPrivacyPolicyOpen: (value: boolean) => void;
}

export const HebrewPersonalInfoSection = ({ 
  form, 
  setTermsOpen, 
  setPrivacyPolicyOpen 
}: HebrewPersonalInfoSectionProps) => {
  return (
    <div className="p-3 md:p-5 bg-blue-50 rounded-lg">
      <h3 className="text-base md:text-lg font-medium text-blue-700 mb-3 md:mb-4 text-right">פרטים אישיים</h3>
      
      <div className="space-y-4 md:space-y-6">
        <PersonalBasicInfoFieldsHe form={form} />
        
        <HebrewTermsCheckbox 
          form={form} 
          setTermsOpen={setTermsOpen} 
          setPrivacyPolicyOpen={setPrivacyPolicyOpen} 
        />
      </div>
    </div>
  );
};
